import { Button } from "@libs/zapi-ui/ds/components/button";
import { useTranslation } from "react-i18next";
import { cn } from "../../../shared/lib/utils";
import type { TSettingsTab } from "./SettingsPage";

export type TSettingsMenuSection = {
  key: string;
  label: string;
  items: { name: TSettingsTab; label: string; icon: React.ReactNode }[];
};

interface SidebarProps extends React.HTMLAttributes<HTMLElement> {
  activeTab: TSettingsTab;
  setActiveTab: (tab: TSettingsTab) => void;
  menuItems: TSettingsMenuSection[];
}

export function Sidebar({ className, activeTab, setActiveTab, menuItems }: SidebarProps) {
  const { t } = useTranslation("settings");

  return (
    <aside className={cn("w-[260px] border-r", className)}>
      <div className="space-y-4 py-[18px]">
        <div className="px-1">
          <p className="typo-h6 text-innoveraZinc-900 ps-[14px]">{t("title")}</p>
          <div className="space-y-1">
            {menuItems.map((section) => (
              <div key={section.key}>
                <h3 className="mb-1 mt-4 px-4 text-[14px] font-medium text-muted-foreground">{section.label}</h3>
                <div className="space-y-1 flex flex-col items-start">
                  {section.items.map((item) => (
                    <Button
                      key={item.name}
                      type="button"
                      data-testid={`settings-sidebar-${item.name.toLowerCase()}-button`}
                      onClick={() => setActiveTab(item.name)}
                      variant={activeTab === item.name ? "secondary" : "ghost"}
                      className="w-full justify-start"
                    >
                      {item.icon}
                      {item.label}
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}
